// Angular
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
// RxJS
import { Subscription } from 'rxjs';

import {  User, AuthService } from '../../../../../core/auth';

@Component({
	selector: 'kt-user-profile',
	templateUrl: './user-profile.component.html',
})
export class UserProfileComponent implements OnInit, OnDestroy {
	// Public properties
	user = new User();
	subscription: Subscription;
	@Input() showAvatar: boolean = true;
	@Input() showHi: boolean = true;
	@Input() showBadge: boolean = false;
	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(private auth: AuthService) {}
			
	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {				
		this.user = JSON.parse(localStorage.getItem('currentUser'));
	}

	ngOnDestroy() {
		this.subscription && this.subscription.unsubscribe();
	}

	/**
	 * Log out
	 */
	logout() {
		//this.store.dispatch(new Logout());
	}
}
